export default __webpack_public_path__ + "static/media/913.c4fb9765.gif";